import { UpcomingMatchesSchema } from '@/views/sports/UpcomingMatches/styles/UpcomingMatches.styles';

export const upcomingMatchesStyles: UpcomingMatchesSchema = {
  pageHeader: {
    fontSize: 'md',
    fontFamily: 'body',
    fontWeight: 'medium',
    textTransform: 'capitalize',
    color: 'beta.600',
  },
  stackWrapper: {
    color: 'white',
    mt: ['-1', null, '0', '-2'],
    py: ['2', null, null, '2'],
    px: ['0', null, null, '4'],
  },
  boxWrapper: {
    alignItems: 'center',
    display: [null, null, null, 'flex'],
    justifyContent: 'space-between',
  },
  sortByText: {
    fontSize: '2xs',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: 'gray.700',
  },
  scrollButtonGroup: {
    variant: 'filter',
    bg: 'none',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderColor: 'blackAlpha.400',
    borderRadius: 'none',
    boxShadow: '0 1px rgba(255, 255, 255, .07)',
    pb: '3',
  },
  flexRenderSortingMobile: {
    justify: 'flex-end',
  },
  loadingSkeletonText: {
    my: '4',
    noOfLines: 2,
    spacing: '4',
    skeletonHeight: '2',
  },
  mainStackWrapper: {
    spacing: '4',
    pt: '2',
  },
  mainStackInner: {
    spacing: '4',
  },
  heading: {
    alignItems: 'center',
    display: 'flex',
    fontSize: 'md',
    gap: '1',
    textTransform: 'capitalize',
    fontWeight: 'medium',
    fontFamily: 'body',
    color: 'beta.600',
  },
  headingIcon: {
    color: 'beta.600',
    sx: {},
  },
  propositionButton: {
    flex: '1',
    height: '38px',
  },
  boxSportWrapper: {
    borderColor: 'whiteAlpha.300',
    borderWidth: '1px',
  },
  buttonSport: {
    h: 'auto',
    borderColor: '#F5CB23',
  },
  buttonAllSports: {
    h: 'auto', 
  }
};
